module.exports = __webpack_public_path__ + "img/学习最高分.55eeef7a.png";